import {
  ManagerProgressionTaskState,
  Sport,
} from '#src/__generated__/globalTypes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

export const useUnclaimedDailyClaimTasksCount = () => {
  const { sport } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const { myCommonDailyClaimTask } = useConfigContext();

  const claimableTasksCount =
    myCommonDailyClaimTask?.aasmState === ManagerProgressionTaskState.COMPLETED
      ? 1
      : 0;

  const isCommonGameOnboarded = () => {
    if (sport === Sport.NBA || sport === Sport.FOOTBALL) {
      return !!currentUser?.anyUserSportProfile?.commonGameOnboarded;
    }
    return false;
  };

  return isCommonGameOnboarded() ? claimableTasksCount : 0;
};
